module.exports = __webpack_public_path__ + "static/media/Laidley Street, San Francisco, CA4.5eddb50a.jpg";